import React, { useState, useEffect } from "react";
import { usePageTransition } from "../../services/hooks/usePageTransition";
import { useRedirect } from "../../services/hooks/useRedirect";
import { useCouponCode } from "../../services/hooks/useCouponCode";
import { useAuth } from "../../services/hooks/useAuth";
import { useSnackbar } from "../../services/hooks/useSnackbar";
import { useRouter } from "next/router";
import Loader from "../../components/Loader";
import storeInLocalStorage from "../../util/storeInLocalStorage";

export default function refer() {
  const { startTransition, completeTransition } = usePageTransition();
  const [loyaltyId, setLoyaltyId] = useState("");
  const { redirect } = useRedirect();
  const { applyCouponCode, couponError, couponId } = useCouponCode();
  const { user, authStatus } = useAuth();
  const router = useRouter();
  const { addSnackbar } = useSnackbar();

  useEffect(() => {
    completeTransition();

    return () => {
      startTransition();
    };
  }, []);

  useEffect(() => {
    const { loyaltyId } = router.query;

    setLoyaltyId(loyaltyId);
  }, [router]);

  useEffect(() => {
    if (loyaltyId && authStatus === "ready") {
      if (!user) {
        applyCouponCode(loyaltyId);
      }

      if (user) {
        if (user.loyaltyId.toLowerCase() !== loyaltyId.toLowerCase()) {
          applyCouponCode(loyaltyId);
        } else {
          addSnackbar(
            `Referral code ${loyaltyId.toUpperCase()} is not valid for this account.`,
            {
              type: "danger",
            }
          );

          redirect("/");
        }
      }
    }
  }, [loyaltyId, authStatus]);

  useEffect(() => {
    if (couponId) {
      storeInLocalStorage("loyaltyId", couponId);

      redirect("/");

      addSnackbar(
        `Referral code ${couponId.toUpperCase()} was automatically applied!`,
        {
          type: "success",
        }
      );
    }

    if (couponError) {
      redirect("/");

      addSnackbar(couponError, {
        type: "danger",
      });
    }
  }, [couponId, couponError]);

  return <Loader />;
}
